module.exports = __webpack_public_path__ + "img/ic-payment-r-paypal-active.c1daec5f.svg";